import { roundToDecimals } from '@/utils/localeFormatters';

import type {
    CombinedBehaviorExportData,
    EnvironmentalExportSnapshot,
    ExportColumnDefinition,
} from '../types';

export const DAYS_TO_EXPORT = 30;

function formatExportDecimal(value: unknown, decimals: number): string | number {
    if (typeof value !== 'number') {
        return '';
    }
    const formatted = roundToDecimals(value, decimals);
    return Number.isNaN(formatted) ? '' : formatted;
}

const formatBehaviorDecimal = (value: unknown): string | number => formatExportDecimal(value, 2);
const formatEnvDecimal = (value: unknown): string | number => formatExportDecimal(value, 1);

export const DAILY_EXPORT_COLUMNS: ExportColumnDefinition<CombinedBehaviorExportData>[] = [
    { key: 'day', labelKey: 'export.date' },
    { key: 'swimSpeed', labelKey: 'common.swimSpeed', formatter: formatBehaviorDecimal },
    {
        key: 'activeSwimSpeed',
        labelKey: 'export.activeSwimSpeed',
        formatter: formatBehaviorDecimal,
    },
    { key: 'respiration', labelKey: 'common.respiration', formatter: formatBehaviorDecimal },
    {
        key: 'activePercent',
        labelKey: 'export.activeRespirationPercent',
        formatter: formatBehaviorDecimal,
    },
    {
        key: 'passivePercent',
        labelKey: 'export.passiveRespirationPercent',
        formatter: formatBehaviorDecimal,
    },
    { key: 'oxygenPercent', labelKey: 'export.oxygenLevel', formatter: formatEnvDecimal },
    { key: 'tilt', labelKey: 'common.tilt', formatter: formatBehaviorDecimal },
    { key: 'temperature', labelKey: 'common.temperature', formatter: formatEnvDecimal },
    { key: 'depth', labelKey: 'common.depth', formatter: formatEnvDecimal },
    {
        key: 'averageSwimSpeed',
        labelKey: 'export.averageSwimSpeed',
        formatter: formatBehaviorDecimal,
    },
    {
        key: 'averageRespiration',
        labelKey: 'export.averageRespiration',
        formatter: formatBehaviorDecimal,
    },
    { key: 'averageTilt', labelKey: 'export.averageTilt', formatter: formatBehaviorDecimal },
];

export const ENVIRONMENTAL_EXPORT_COLUMNS: ExportColumnDefinition<EnvironmentalExportSnapshot>[] = [
    { key: 'lastMeasurement', labelKey: 'export.environmentalLastMeasurement' },
    {
        key: 'oxygenSaturation',
        labelKey: 'export.environmentalOxygen',
        formatter: formatEnvDecimal,
    },
    {
        key: 'oxygenConcentration',
        labelKey: 'export.environmentalOxygenConcentration',
        formatter: formatEnvDecimal,
    },
    { key: 'salinity', labelKey: 'export.environmentalSalinity', formatter: formatEnvDecimal },
    {
        key: 'temperature',
        labelKey: 'export.environmentalTemperature',
        formatter: formatEnvDecimal,
    },
    { key: 'depth', labelKey: 'export.environmentalDepth', formatter: formatEnvDecimal },
];
